<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h2>Descargas</h2>
          <p>
            En este apartado se pueden generar algunos archivos con información
            relevante.
          </p>
          <b-row class="mb-3">
            <b-col :cols="12"> </b-col>
          </b-row>

          <b-row>
            <b-col :cols="12" class="mb-4">
              <b-card-group deck>
                <b-card title="Base de clientes" tag="article">
                  <b-card-text>
                    Genera un archivo CSV con los datos de todos los clientes,
                    incluídas sus direcciones de envío y facturación.
                    <br /><br />Por seguridad, es necesario introducir el código
                    MFA (6 dígitos) para iniciar la descarga.
                  </b-card-text>

                  <template #footer>
                    <b-input-group prepend="Código MFA:">
                      <b-form-input
                        v-model="customerBaseMFA.customerBase"
                        type="text"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button @click="downloadCusomerBase" variant="primary"
                          >Descargar</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                    <p v-if="showError.customerBase" class="text-danger">
                      El código introducido no es correcto
                    </p>
                  </template>
                </b-card>

                <b-card title="Productos más vendidos" tag="article">
                  <b-card-text>
                    Genera un archivo CSV con los productos más vendidos.
                  </b-card-text>

                  <template #footer>
                    <b-button
                      @click="downloadMostPurchasedProducts"
                      variant="primary"
                      >Descargar</b-button
                    >
                  </template>
                </b-card>
                <b-card title="Telas más vendidas" tag="article">
                  <b-card-text>
                    Genera un archivo CSV con las telas más vendidas.
                  </b-card-text>

                  <template #footer>
                    <b-button
                      @click="downloadMostPurchasedFabrics"
                      variant="primary"
                      >Descargar</b-button
                    >
                  </template>
                </b-card>
                <b-card
                  title="Productos más vendidos (desglose telas)"
                  tag="article"
                >
                  <b-card-text>
                    Genera un archivo CSV con los productos más vendidos,
                    desglosados por telas.
                  </b-card-text>

                  <template #footer>
                    <b-button
                      @click="downloadMostPurchasedProductsFabrics"
                      variant="primary"
                      >Descargar</b-button
                    >
                  </template>
                </b-card>
              </b-card-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col :cols="3">
              <b-card-group>
                <b-card title="Ventas por cliente" tag="article">
                  <b-card-text>
                    Genera un archivo Excel con las ventas por cliente,
                    incluyendo las facturas emitidas.
                    <br /><br />Por seguridad, es necesario introducir el código
                    de doble autenticación para iniciar la descarga.
                  </b-card-text>

                  <template #footer>
                    <b-input-group prepend="Código MFA:">
                      <b-form-input
                        v-model="customerBaseMFA.customerBaseOrders"
                        type="text"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          :disabled="downloadCusomerBaseOrdersBtnDisabled"
                          @click="downloadCusomerBaseOrders"
                          variant="primary"
                          >Descargar</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                    <p v-if="showError.customerBaseOrders" class="text-danger">
                      El código introducido no es correcto
                    </p>
                  </template>
                </b-card>
              </b-card-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { uris, actions } from '@/admin/api.js';

import store from '@/admin/store.js';

export default {
  name: 'AdminAnalyticsDownloadsScreen',
  props: {},
  components: {},
  data() {
    return {
      downloadCusomerBaseOrdersBtnDisabled: false,
      customerBaseMFA: {
        customerBase: '',
        customerBaseOrders: '',
      },
      showError: {
        customerBase: false,
        customerBaseOrders: false,
      },

      sharedState: store.state,
    };
  },
  created() {},
  methods: {
    downloadCusomerBase() {
      actions
        .postAnalyticsDownloadCustomerBase({
          mfa_code: this.customerBaseMFA.customerBase,
        })
        .then((x) => {
          this.showError.customerBase = false;
          let fileName = 'base_clientes.csv';

          const contentDisposition = x.headers['content-disposition'];
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+)/);
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1];
            }
          }

          let blob = new Blob([x.data], { type: 'text/csv' });

          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
        })
        .catch((y) => {
          this.showError.customerBase = true;
        });
    },
    downloadMostPurchasedProducts() {
      actions
        .postAnalyticsDownloadMostPurchasedProducts()
        .then((x) => {
          let fileName = 'productos_mas_vendidos.csv';

          const contentDisposition = x.headers['content-disposition'];
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+)/);
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1];
            }
          }

          let blob = new Blob([x.data], { type: 'text/csv' });

          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
        })
        .catch((y) => {});
    },
    downloadMostPurchasedFabrics() {
      actions
        .postAnalyticsDownloadMostPurchasedFabrics()
        .then((x) => {
          let fileName = 'telas_mas_vendidas.csv';

          const contentDisposition = x.headers['content-disposition'];
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+)/);
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1];
            }
          }

          let blob = new Blob([x.data], { type: 'text/csv' });

          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
        })
        .catch((y) => {});
    },
    downloadMostPurchasedProductsFabrics() {
      actions
        .postAnalyticsDownloadMostPurchasedProductsFabrics()
        .then((x) => {
          let fileName = 'productos_mas_vendidos_telas.csv';

          const contentDisposition = x.headers['content-disposition'];
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+)/);
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1];
            }
          }

          let blob = new Blob([x.data], { type: 'text/csv' });

          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
        })
        .catch((y) => {});
    },
    downloadCusomerBaseOrders() {
      this.downloadCusomerBaseOrdersBtnDisabled = true;
      actions
        .postAnalyticsDownloadCustomerBaseOrders({
          mfa_code: this.customerBaseMFA.customerBaseOrders,
        })
        .then((x) => {
          this.showError.customerBaseOrders = false;
          let fileName = 'ventas por cliente.xlsx';

          const url = window.URL.createObjectURL(new Blob([x.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();

          this.downloadCusomerBaseOrdersBtnDisabled = false;
        })
        .catch((y) => {
          this.showError.customerBaseOrders = true;
          this.downloadCusomerBaseOrdersBtnDisabled = false;
        });
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
